// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InteractivePodsCarousel_wrapper__BUfOO","carousel":"InteractivePodsCarousel_carousel__oCXgL","pod_wrapper":"InteractivePodsCarousel_pod_wrapper__Lwjah"};